import { Link } from "react-router-dom";
import '../../styles/ServiceStyles/ServiceOverview.css';

const ServiceOverview = () => {
    return (
        <>
            <header className="km-pageHeader">
                <div className="km-container km-enter">
                    <p className="km-eyebrow">Services</p>
                    <h1>SAHPRA Licensing Services</h1>
                    <p className="km-lead">
                        Choose the licence that matches your business. We guide you through every step, from
                        application and document preparation to regulatory compliance and approval.
                    </p>
                </div>
            </header>

            <section className="km-section ServiceOverviewContainer">
                <div className="km-container service-why">
                    <div data-reveal>
                        <p className="km-eyebrow">Why it matters</p>
                        <h2 className="km-title">Why you need a SAHPRA licence</h2>
                        <p className="km-lead">
                            SAHPRA (the South African Health Products Regulatory Authority) is the national body responsible for
                            ensuring the safety, quality and compliance of medical devices and health products in South Africa.
                        </p>
                        <p className="service-body">
                            Any business involved in the <strong>manufacturing</strong>, <strong>importing</strong>,{" "}
                            <strong>distributing</strong> or selling of medical devices is legally required to hold a valid SAHPRA
                            establishment licence. The licence is also essential for companies that want to qualify
                            for <strong>government and provincial tenders</strong>.
                        </p>
                    </div>
                    <aside className="service-promise" data-reveal style={{ "--reveal-order": 1 } as React.CSSProperties}>
                        <p className="service-promise-title">We help you get licensed faster, correctly and with full confidence.</p>
                        <ul>
                            <li>Licence application guidance</li>
                            <li>Document preparation</li>
                            <li>Regulatory compliance checks</li>
                            <li>Support through to approval</li>
                        </ul>
                        <Link className="km-btn km-btn--accent km-btn--block" to="/quote">Request a Quote</Link>
                    </aside>
                </div>
            </section>
        </>
    );
};

export default ServiceOverview;
